import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import * as Sentry from "@sentry/react";
import '@babel/polyfill';
import Root from './Root';

// if (process.env.NODE_ENV !== 'development') {
Sentry.init({
  dsn: "https://07675013590242418c7fb85c1017e78f@o168617.ingest.sentry.io/1245296",
  integrations: [Sentry.browserTracingIntegration()],
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV !== 'development',
  ignoreErrors:[
    "Non-Error exception captured",
    "Non-Error promise rejection captured"
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
});
// }

let gaMeasurementId = 'G-61TB53KFND'; // TODO: change to test once created
const options = {};
options.testMode = false;
if (process.env.NODE_ENV === 'production') {
  gaMeasurementId = 'G-61TB53KFND';
  options.testMode = false;
}
ReactGA.initialize(gaMeasurementId, options);

// Create root once and store it
let root = null;

const render = Component => {
  if (!root) {
    const container = document.getElementById('root');
    root = createRoot(container);
  }
  root.render(<Component />);
};

if (module.hot) {
  module.hot.accept('./Root', () => {
    console.log('HMR: Accepting Root update');
    try {
      const NextRoot = require('./Root').default;
      render(NextRoot);
    } catch (error) {
      console.error('Error applying HMR update:', error);
    }
  });
}
render(Root);